import { QueryClient } from '@tanstack/react-query';

// Create a QueryClient instance with default configuration
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // VERY conservative defaults - let individual queries override as needed
      staleTime: 1000 * 60 * 60, // 1 hour default
      gcTime: 1000 * 60 * 60 * 24, // 24 hours default (formerly cacheTime in v4)
      refetchOnWindowFocus: false,
      retry: 1,
      // Disable automatic refetching
      refetchOnMount: true, // Default behavior - individual queries can override
      refetchOnReconnect: false,
    },
  },
});